import { useAppSelector } from "../../../redux/store";
import { useEffect } from "react";
import { supportedLanguages } from "../../../constants";

export const Message = (props: MessageProps) => {
  const { messageCache } = useAppSelector((state) => state.messagesReducer);
  const { messageKey, sectionId, isHtml } = props;
  const { languageId } = useAppSelector((state) => state.messagesReducer);

  const mainSectionMessages = messageCache[MessageSections.MAIN];
  const sectionMessages = messageCache[sectionId];
  const message = messageKey
    ? (sectionMessages && sectionMessages[messageKey]) ||
      (mainSectionMessages && mainSectionMessages[messageKey])
    : undefined;

  useEffect(() =>
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    {}, [messageCache]);

  return (
    <>
      {message && message.name
        ? isHtml ? <div dangerouslySetInnerHTML={{__html: message.name}}></div> : message.name
        : isHtml ? <div dangerouslySetInnerHTML={{__html: supportedLanguages[languageId - 1] + "_" + messageKey}}></div> : supportedLanguages[languageId - 1] + "_" + messageKey}
    </>
  );
};

interface MessageProps {
  messageKey: string | undefined;
  sectionId: MessageSections;
  isHtml?: boolean;
}

export enum MessageSections {
  MAIN = "main",
  LOGIN = "login",
  ORDERS = "orders",
  USER = "user",
  PROHIBITED = "prohibited",
  CALCULATE = "calculate",
}
